import { Entity, EntityMap } from '../types';

export enum DismissablePromptKey {
  AnswersFAQifyOnboardingFRE = 'AnswersFAQifyOnboardingFRE',
  AnswersCommunityFAQifyCoachingBar = 'AnswersCommunityFAQifyCoachingBar',
  FirstRunExperience = 'FirstRunExperience',
  FirstRunExperienceStoryline = 'FirstRunExperienceStoryline',
  FirstRunExperienceStorylineInVivaEngage = 'FirstRunExperienceStorylineInVivaEngage',
  GroupSidebarLeadershipCornerCard = 'GroupSidebarLeadershipCornerCard',
  LeadersDirectoryConnectedLeaders = 'LeadersDirectoryConnectedLeaders',
  LeadersDirectoryFollowedLeaders = 'LeadersDirectoryFollowedLeaders',
  LeadersDirectoryAllLeaders = 'LeadersDirectoryAllLeaders',
  LeadershipCornerBanner = 'LeadershipCornerBanner',
  LeadershipCornerPinnedPostFRE = 'LeadershipCornerPinnedPostFRE',
  LeaderPublisherContentSuggestions = 'LeaderPublisherContentSuggestions',
  LightboxFollowUsers = 'LightboxFollowUsers',
  LightboxJoinGroups = 'LightboxJoinGroups',
  LockedAchievementsFRE = 'LockedAchievementsFRE',
  MobileCrossSellQRCode = 'MobileCrossSellQRCode',
  MobileCrossSellThreadViewBannerAd = 'MobileCrossSellThreadViewBanner',
  MobileCrossSellThreadViewCoachingBar = 'MobileCrossSellThreadViewCoachingBar',
  MobileUpsell = 'MobileUpsell',
  NetworkQuestionsUpvoteBubble = 'NetworkQuestionsUpvoteBubble',
  OutlookEngageRebrandingBanner = 'OutlookEngageRebrandingBanner',
  OutlookAnswersDigestBanner = 'OutlookAnswersDigestBanner',
  PublisherSaveAsDraftPrompt = 'PublisherSaveAsDraftPrompt',
  PublisherQuestionCoachingTip = 'PublisherQuestionCoachingTip',
  PublisherQuestionPromptFRE = 'PublisherQuestionPromptFRE',
  PushNotifications = 'PushNotifications',
  PWAInstall = 'PWAInstall',
  PushNotificationsRenew = 'PushNotificationsRenew',
  PWAInstallRenew = 'PWAInstallRenew',
  StorylineAnnouncementTeachingBubble = 'StorylineAnnouncementTeachingBubble',
  VivaEngageFRE = 'VivaEngageFRE',
  VivaEngageAmaCreationPromotion = 'VivaEngageAmaCreationPromotion',
  VivaEngageInOutlookFRE = 'VivaEngageInOutlookFRE',
  VivaEngageRebrandingNonAdminBanner = 'VivaEngageRebrandingNonAdminBanner',
  VivaEngageRebrandingAdminBanner = 'VivaEngageRebrandingAdminBanner',
}

export interface DismissablePrompt extends Entity {
  readonly isDismissed: boolean;
}

export type DismissablePrompts = EntityMap<DismissablePrompt>;
